import { useEffect, useRef } from "react";

export function usePortal() {
  const portalDiv = useRef(null);

  useEffect(() => {
    if (!portalDiv.current) {
      const div = document.createElement("div");
      div.setAttribute("data-tooltip-portal", "");
      document.body.appendChild(div);
      portalDiv.current = div;
    }
    return () => {
      if (portalDiv.current) {
        if (portalDiv.current.parentNode === document.body) {
          document.body.removeChild(portalDiv.current);
        }
        portalDiv.current = null;
      }
    };
  }, []);

  return portalDiv.current;
}
